import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

// Generic pill badge (no cva). Domain status badges live in StatusBadge.tsx.
export type BadgeVariant = "default" | "success" | "warning" | "danger" | "muted";

const VARIANTS: Record<BadgeVariant, string> = {
  default: "border-blue-bg bg-blue-bg-soft text-blue",
  success: "border-green-bg bg-green-bg text-green-dark",
  warning: "border-warning-border bg-warning-bg text-warning",
  danger: "border-red-border bg-red-bg text-red",
  muted: "border-grey-200 bg-grey-100 text-grey-600",
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export function Badge({ variant = "default", className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill border px-2.5 py-0.5 text-xs font-medium",
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  );
}
